import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LoginService } from '../login/login.service';
import { map } from 'rxjs';
import { ROUTE_CONSTANTS } from '../../util/route.constants';
import { StorageKeys } from '../../util/constants';
import { hasAuthTokens } from '../../util/auth-tokens.util';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const loginService = inject(LoginService);
  const isFirstLogin = localStorage.getItem("firstLogin");

  return loginService.isLoggedIn().pipe(
    map((loggedIn: boolean) => {
      //navigate to reset password when user has first login      
      if (loggedIn && hasAuthTokens()) {
        if(!localStorage.getItem(StorageKeys.FACILITY_CODE) && state.url !== '/' + ROUTE_CONSTANTS.FACILITY_SELECTION) {
          router.navigate([ROUTE_CONSTANTS.FACILITY_SELECTION]);
          return false;
        } else {
          loginService.selectedFacility.next((localStorage.getItem(StorageKeys.FACILITY_CODE) ?? '') + ' - ' + (localStorage.getItem(StorageKeys.FACILITY_NAME) ?? ''));
        }
        loginService.loggedIn$.next(true);
        if (isFirstLogin === "true" && state.url!=='/'+ROUTE_CONSTANTS.CHANGE_PASSWORD) {
          console.log('user logged in first time.')
          router.navigate([ROUTE_CONSTANTS.CHANGE_PASSWORD]);
          return false;
        }        
        return true;
      }
      else
        router.navigate([ROUTE_CONSTANTS.LOGIN]);
      return false;
    })
  );
};
